(function ($) {
  $(document).ready(function ($) {
    console.log('Menu & Navigation JS');

    // add scrolltrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    // Responsive
    // ---
    ScrollTrigger.matchMedia({
      // large
      '(max-width: 767px)': function () {
        /*****************************************************************
          Opening & closing the mobile navigation menu
        ******************************************************************/
        $('#mobile-navBtn').click(function (event) {
          if ($('body').hasClass('menu-open')) {
            $('body').removeClass('menu-open');
            $('.back-to-level-1').parent().parent().removeClass('show-level-2');
            $('.back-to-level-2').parent().parent().removeClass('show-level-3');
          } else {
            $('body').addClass('menu-open');
          }
        });

        $('.show-submenu').click(function (event) {
          event.preventDefault();

          if ($(this).parent().parent().hasClass('level-1')) {
            console.log('show 1');
            $(this).siblings('.level-2').addClass('show-level-2');
          } else if ($(this).parent().parent().hasClass('level-2')) {
            console.log('show 2');
            $(this).siblings('.level-3').addClass('show-level-3');
          } else {
            console.log('how did we get here?');
          }
        });

        $('.back-to-level-1').click(function (event) {
          $(this).parent().parent().removeClass('show-level-2');
        });

        $('.back-to-level-2').click(function (event) {
          $(this).parent().parent().removeClass('show-level-3');
        });
      },
      // large
      '(min-width: 767px)': function () {},
      // all
      all: function () {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
      },
    });
    // ---
    // END Responsive
  });
})(jQuery);
